<template>
  <div class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-8 md:px-6 lg:px-8 xl:px-20 xl:mb-12">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="1"
          />
        </div>
      </div>

      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg">
            <h1 class="text-3xl font-bold xl:text-3.25xl text-sn-secondary uppercase max-w-220 leading-11.5 mb-10">
              {{ tr('pages.sales.buy.title') }}
            </h1>
            <p class="leading-7.5 text-2xl">
              {{ tr('pages.sales.buy.description') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-3 pb-16 md:pt-12 md:pb-0">
      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="flex flex-col justify-between w-full xl:flex-row-reverse">
            <VoucherAmountSelector class="w-full p-6 bg-sn-gray-100 xl:max-w-183" />
            <div class="w-full mb-12 md:flex md:max-w-none md:mb-8 xl:max-w-120 xl:block xl:pr-6 xl:mr-6 xl:mb-0">
              <div class="mt-12 xl:text-lg xl:w-full">
                <ul class="space-y-9 list-checkmark-2 text-sn-gray-900 text-base">
                  <li v-html="tr('pages.sales.buy.cards.point1')" />
                  <li v-html="tr('pages.sales.buy.cards.point3')" />
                  <li v-html="tr('pages.sales.buy.cards.point4')" />
                  <li v-html="tr('pages.sales.buy.cards.point5')" />
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mb-12 xl:mb-32 md:mt-20 xl:mt-40">
        <HowItWorks />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/brussels/sale/how-it-works.vue'
import VoucherAmountSelector from '~brand-components/brussels/sale/voucher-amount-selector.vue'
import StepNavigation from '~brand-components/brussels/navigation/step-navigation.vue'
export default Vue.extend({
  components: {
    HowItWorks,
    VoucherAmountSelector,
    StepNavigation,
  },
})
</script>
